<style>
html {
  overflow-y: auto;
}
.main-content {
  background: #e8da49;
  background: -moz-linear-gradient(45deg, #e8da49 0%, #ed3828 100%);
  background: -webkit-linear-gradient(45deg, #e8da49 0%, #ed3828 100%);
  background: linear-gradient(45deg, #e8da49 0%, #ed3828 100%);
}
</style>
<template>
  <v-app>
    <Navbar />

    <v-main class="main-content px-5 orange">
      <router-view></router-view>
    </v-main>

    <Footer />
  </v-app>
</template>

<script>
document.title = "Raging Pixel Studios";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default {
  name: "App",
  components: {
    Navbar,
    Footer
  },

  data: () => ({
    //
  })
};
</script>
